export const JOB_PROGRESS_SEGMENTS = {
  PROFILING: 'profiling',
  SEARCHING: 'searching',
  INTERVIEWING: 'interviewing',
  CLOSING: 'closing',
};

export const JOB_PROGRESS_SWITCH_ENTITY_ID_REGEXP =
  /(jobs|contracts)\/?([\w\-]+)/;
